import ToC from "./toc-mdx-2"

export default ToC